(() => {
  'use strict';

  const mounted = new WeakMap();
  const macroImages = {
    Oak: window.HomewoodsAssetUrls["assets/homewoods-finish-macro-v1/homewoods-macro-oak-v1.webp"],
    'Light Oak': window.HomewoodsAssetUrls["assets/homewoods-finish-macro-v1/homewoods-macro-light-oak-v1.webp"],
    'Grey Oak': window.HomewoodsAssetUrls["assets/homewoods-finish-macro-v1/homewoods-macro-grey-oak-v1.webp"],
    'Smoked Oak': window.HomewoodsAssetUrls["assets/homewoods-finish-macro-v1/homewoods-macro-smoked-oak-v1.webp"],
    Grey: window.HomewoodsAssetUrls["assets/homewoods-finish-macro-v1/homewoods-macro-grey-v1.webp"],
    Sand: window.HomewoodsAssetUrls["assets/homewoods-finish-macro-v1/homewoods-macro-sand-v1.webp"],
    Walnut: window.HomewoodsAssetUrls["assets/homewoods-finish-macro-v1/homewoods-macro-walnut-v1.webp"],
    Black: window.HomewoodsAssetUrls["assets/homewoods-finish-macro-v1/homewoods-macro-black-v1.webp"]
  };
  const finishGuide = {
    Oak: ['Warm & natural', 'Warm', 'Pair with soft whites, natural fabrics and a little greenery.'],
    'Light Oak': ['Light & airy', 'Light', 'A gentle starting point for pale walls, linen and relaxed spaces.'],
    'Grey Oak': ['Cool & considered', 'Cool', 'Bring balance to warm upholstery, black details and muted colours.'],
    'Smoked Oak': ['Deep & grounded', 'Deep', 'Build a cosy mood with warm lighting and soft, tactile fabrics.'],
    Grey: ['Quiet & balanced', 'Cool', 'Layer with stone tones, clean lines and a small accent of colour.'],
    Sand: ['Soft & sunlit', 'Light', 'Keep the palette gentle with cream, chalky whites and woven textures.'],
    Walnut: ['Rich & inviting', 'Warm', 'Let the darker grain sit alongside warm neutrals and simple furnishings.'],
    Black: ['Bold & sculptural', 'Deep', 'Create a focal point against lighter walls and understated furniture.']
  };

  function mount(studio) {
    if (mounted.has(studio)) return;
    const root = studio.closest('[data-homewoods]') || document;
    const form = root.querySelector('[data-hw-product-form]');
    const select = form?.querySelector('[data-variant-select]');
    const fieldset = form?.querySelector('[data-finish-fieldset]');
    if (!select || !fieldset) return;

    const finishes = Array.from(fieldset.querySelectorAll('[data-finish-select]')).map((swatch) => {
      const option = Array.from(select.options).find((item) => item.value === swatch.dataset.finishSelect);
      const image = swatch.querySelector('img');
      const name = swatch.querySelector('.hw-swatch__name')?.textContent.trim();
      if (!option || !image || !name) return null;
      return { id: option.value, name, swatch, option, image, guide: finishGuide[name] || ['Your finishing touch', 'Explore', 'Consider the colours, materials and lighting already in your room.'] };
    }).filter(Boolean);
    if (!finishes.length) return;

    const grid = studio.querySelector('[data-studio-grid]');
    const choose = studio.querySelector('[data-studio-choose]');
    const current = studio.querySelector('[data-studio-current]');
    const status = studio.querySelector('[data-studio-status]');
    const previewImage = studio.querySelector('[data-studio-image]');
    let activeId = select.value;
    let previewId = activeId;

    finishes.forEach((finish) => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'hw-finish-card';
      card.dataset.studioFinish = finish.id;
      card.setAttribute('aria-label', `Preview ${finish.name}`);
      card.setAttribute('aria-pressed', 'false');
      const imageWrap = document.createElement('span');
      imageWrap.className = 'hw-finish-card__image-wrap';
      const image = document.createElement('img');
      image.className = 'hw-finish-card__image';
      image.src = macroImages[finish.name] || finish.image.currentSrc || finish.image.src;
      image.width = 180;
      image.height = 240;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      const check = document.createElement('span');
      check.className = 'hw-finish-card__check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      imageWrap.append(image, check);
      const name = document.createElement('span');
      name.className = 'hw-finish-card__name';
      name.textContent = finish.name;
      const tone = document.createElement('span');
      tone.className = 'hw-finish-card__tone';
      tone.textContent = finish.guide[1];
      card.append(imageWrap, name, tone);
      finish.card = card;
      grid.append(card);
    });

    function render(id, announce = false) {
      const finish = finishes.find((item) => item.id === id) || finishes[0];
      previewId = finish.id;
      previewImage.src = macroImages[finish.name] || finish.option.dataset.image || finish.image.currentSrc || finish.image.src;
      previewImage.width = 1086;
      previewImage.height = 1448;
      previewImage.alt = `${finish.name} panel finish, close-up of the slatted surface`;
      studio.querySelector('[data-studio-name]').textContent = finish.name;
      studio.querySelector('[data-studio-tone]').textContent = finish.guide[0];
      studio.querySelector('[data-studio-guidance]').textContent = finish.guide[2];
      finishes.forEach((item) => item.card.setAttribute('aria-pressed', String(item.id === previewId)));
      choose.disabled = select.disabled || finish.swatch.disabled || finish.option.disabled;
      choose.setAttribute('aria-label', `Choose ${finish.name} and continue to panel quantity`);
      if (announce) status.textContent = `Previewing ${finish.name}. ${finish.guide[0]}. Use Choose this finish to select it.`;
    }

    function syncNative() {
      const selected = finishes.find((finish) => finish.id === select.value);
      if (!selected) return;
      current.textContent = selected.name;
      if (activeId !== select.value) {
        activeId = select.value;
        render(activeId);
      } else {
        const preview = finishes.find((finish) => finish.id === previewId);
        choose.disabled = select.disabled || preview.swatch.disabled || preview.option.disabled;
      }
    }

    function onPreview(event) {
      const card = event.target.closest('[data-studio-finish]');
      if (card && grid.contains(card)) render(card.dataset.studioFinish, true);
    }

    function onChoose() {
      const finish = finishes.find((item) => item.id === previewId);
      if (!finish || choose.disabled || select.disabled || finish.swatch.disabled || finish.option.disabled) return;
      select.value = finish.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncNative();
      status.textContent = `${finish.name} selected. Continue with your panel quantity.`;
      const purchase = root.querySelector('[data-hw-product]');
      if (purchase) {
        purchase.focus({ preventScroll: true });
        purchase.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }

    grid.addEventListener('click', onPreview);
    choose.addEventListener('click', onChoose);
    root.addEventListener('change', syncNative);
    const observer = new MutationObserver(syncNative);
    observer.observe(fieldset, { subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'disabled'] });
    observer.observe(select, { attributes: true, attributeFilter: ['disabled'] });
    render(activeId);
    syncNative();
    studio.querySelector('[data-finish-studio-ui]').hidden = false;
    mounted.set(studio, () => {
      observer.disconnect();
      grid.removeEventListener('click', onPreview);
      choose.removeEventListener('click', onChoose);
      root.removeEventListener('change', syncNative);
      grid.replaceChildren();
      mounted.delete(studio);
    });
  }

  const scan = (container) => container.querySelectorAll('[data-finish-studio]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-finish-studio]').forEach((studio) => mounted.get(studio)?.()));
})();
